import configData from "../config.json";
import { authHeader, handleResponse } from '../_helpers/index';

export const userService = {
    getAll
};

function getAll() {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(`${configData.API_URL}/users`, requestOptions).then(handleResponse);
}